import React from 'react';
import Radium from 'radium';
import Theme from '../../styles/theme';

export class Link extends React.Component {
	static propTypes = {
		style: React.PropTypes.object,
		url: React.PropTypes.string,
		children: React.PropTypes.node.isRequired,
		newTab: React.PropTypes.bool,
		onTouchTap: React.PropTypes.func,
	};

	static defaultProps = {
		newTab: false,
	};

	render() {
		const { style, children, url, newTab, onTouchTap, ...leftover } = this.props;

		const linkstyle = {
			color: Theme.palette.primary3Color,
			cursor: 'pointer',
			transitionTimingFunction: 'ease',
			transitionDuration: '240ms',
			textDecoration: 'none',
			':hover': {
				color: Theme.palette.primary1Color,
			},
			...style,
		};

		return (
			<a
				href={url}
				style={linkstyle}
				target={newTab ? '_blank' : '_self'}
				onTouchTap={onTouchTap}
				onClick={onTouchTap}
				{...leftover}
			>
				{children}
			</a>
		);
	}
}

export default Radium(Link);



// WEBPACK FOOTER //
// ./src/components/links/Link.js